(function () {
  'use strict';
  if (window.KoppaConsent) return;
  var api;
  // The first privacy read is the saved baseline, not a new withdrawal.
  // Starting with analyticsDeclined:false reloaded every page for visitors
  // whose saved choice was "no", interrupting the page and its images forever.
  var last = null;
  var googleStarted = false;
  var reloading = false;
  var clarityStarted = false;
  var klaviyoStarted = false;

  function state() {
    try {
      var consent = api.currentVisitorConsent();
      return {
        // Explicit opt-in: still gates Clarity, Klaviyo onsite and the OpenAI pixel.
        analytics: consent.analytics === 'yes' && api.analyticsProcessingAllowed(),
        // Explicit opt-out: the only thing that stops Amplitude (decision 2026-09-27,
        // same as GA4 above: the banner is only shown in the EU/UK, so waiting for a
        // "yes" left most visitors unmeasured).
        analyticsDeclined: consent.analytics === 'no',
        marketing: consent.marketing === 'yes' && api.marketingAllowed() &&
          api.saleOfDataAllowed() && navigator.globalPrivacyControl !== true
      };
    } catch (_) { return { analytics: false, analyticsDeclined: false, marketing: false }; }
  }

  function script(src) {
    var element = document.createElement('script');
    element.src = src;
    element.async = true;
    document.head.appendChild(element);
  }

  function afterLoad(fn) {
    var idle = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
      else window.setTimeout(fn, 1);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  window.KoppaConsent = {
    // Used by the Amplitude scripts: allowed unless the visitor explicitly declined.
    analyticsAllowed: function () { return !state().analyticsDeclined; },
    // Explicit opt-in, for anything that must wait for a "yes".
    analyticsOptedIn: function () { return state().analytics; },
    marketingAllowed: function () { return state().marketing; },
    openPreferences: function () {
      if (window.privacyBanner && window.privacyBanner.showPreferences) {
        return window.privacyBanner.showPreferences();
      }
      return Promise.reject(new Error('Privacy preferences are unavailable.'));
    }
  };

  window.dataLayer = window.dataLayer || [];
  var queueGoogle = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag = function () {
    if (arguments[0] === 'event') startGoogle();
    queueGoogle.apply(window, arguments);
  };
  window.gtag('consent', 'default', {
    analytics_storage: 'granted', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied'
  });

  function startGoogle() {
    if (googleStarted) return;
    googleStarted = true;
    window.gtag('js', new Date());
    window.gtag('config', 'G-7P09QL5XV6', {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    });
    afterLoad(function () {
      if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js?id=G-7P09QL5XV6"]')) {
        script('https://www.googletagmanager.com/gtag/js?id=G-7P09QL5XV6');
      }
    });
  }

  function stopAnalytics(declined) {
    if (clarityStarted && window.clarity) window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
    if (!declined) return;
    var amplitude = window.koppaAmplitude;
    if (amplitude) {
      if (typeof amplitude.setOptOut === 'function') amplitude.setOptOut(true);
      try {
        var replay = typeof amplitude.sessionReplay === 'function' ? amplitude.sessionReplay() : null;
        if (replay && typeof replay.shutdown === 'function') replay.shutdown();
      } catch (_) {}
    }
  }

  function sync() {
    var next = state();
    var revoked = last && ((last.analytics && !next.analytics) || (last.marketing && !next.marketing) ||
      (!last.analyticsDeclined && next.analyticsDeclined));
    last = next;
    window.dispatchEvent(new CustomEvent('koppa:consent', { detail: next }));
    if (!next.analytics) stopAnalytics(next.analyticsDeclined);
    if (revoked && !reloading) {
      reloading = true;
      window.location.reload();
      return;
    }
    if (next.marketing && next.analytics && !klaviyoStarted && !reloading) {
      klaviyoStarted = true;
      script('https://static.klaviyo.com/onsite/js/XVHRc2/klaviyo.js?company_id=XVHRc2');
    }
    if (!next.analytics || reloading) return;
    if (!clarityStarted) {
      clarityStarted = true;
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: next.marketing ? 'granted' : 'denied' });
      script('https://www.clarity.ms/tag/yfkzlmdtm3?ref=shopify');
    } else window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: next.marketing ? 'granted' : 'denied' });

  }

  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-koppa-cookie-preferences]');
    if (!link) return;
    event.preventDefault();
    window.KoppaConsent.openPreferences().catch(function () { window.location.assign(link.href); });
  });
  var attempts = 0;
  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      api = window.Shopify.customerPrivacy;
      sync();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) return;
        api = window.Shopify.customerPrivacy;
        sync();
      });
    } else if (++attempts < 100) window.setTimeout(loadPrivacy, 100);
  }
  loadPrivacy();
})();
